<template>
  <div>
    <div class="block-images">
      <style-image v-for="item in galleryData" :key="item.artist_id" 
        :artistData="item" v-on:click="showZoomPortfolio" :pageSettings="pset" :gallery="gallery" />
    </div>
    <zoom-image :visible="showZoom" 
          v-on:prev="zoomImage(-1)" v-on:next="zoomImage(1)"
          :image="selImage" v-on:close="closeZoom" :artist="artist" />
  </div>
</template>

<script>
import StyleImage from '@/components/widgets/StyleImageV2.vue'
import ZoomImage from '@/components/panels/ZoomImage.vue'

export default {
  components: {
    StyleImage,
    ZoomImage
  },
  props:{
    galleryData: {
      type: Array,
      default: function () { return [] }
    },
    gallery: Object
  },
  data () {
    return {
      scrolled: false,
      loadedChunks: 0,
      maxChunks: 0,
      initialLoadComplete: false,
      artist: {},
      selImage: null,
      images: [],
      showZoom: false,
      rowWidth: 5,
      pset: ''
    }
  },
  
  mounted: function () {
    
    window.addEventListener('scroll', () => {
      this.windowScrolled()
    })
  },
  methods: {
    getCurrentPos: function () {
      if(!this.selImage.image_id) return -1
      return this.images.findIndex(el => el.image_id === this.selImage.image_id)
    },
    zoomImage: function (moveRel) {
      let pos = this.getCurrentPos()
      //console.log('pos is ' + pos)
      if(pos < 0) {
        pos = 0
      }
      else {
        pos += moveRel
        if(pos < 0) {
          pos = this.images.length - 1
        }
        else if (pos >= this.images.length) {
          pos = 0;
        }
      }
      this.selImage = this.images[pos]
    },
    windowScrolled: function () {
      if(!this.scrolled) {
        if(this.maxChunks > this.loadedChunks){
          if((window.scrollY > 400) && this.initialLoadComplete) {
            this.scrolled = true
            this.finishLoading()
          }

        }
      }
    },
    fetchGalleryImagesForArtist: async function (artist) {
      let res = this.$store.state.artistImages[artist.artist_id]
      if(!res) {
        res = await this.$apix.post('collections/images', { artist_id: Number(artist.artist_id) })
        res = res.data
        this.$store.commit('setArtistImages', { id: artist.artist_id, data: res })
      }
      let gid = this.galleryData[0].gallery_id
      let gallery = await this.$store.getters.gallery(gid)
      let gurl = gallery.url
      this.images = res.filter(el => el.galleries.includes(gurl))
    },
    async showZoomPortfolio(item) {
      console.log('called showZoomPortfolio')
      console.log('item', item)
      this.artist = item.artist
      await this.fetchGalleryImagesForArtist(this.artist)
      
      this.selImage = this.images.find(el => el.image_id === item.image)
      this.showZoom = true
      
    },
    closeZoom: function () {
      this.showZoom = false
    }
  },
  watch: {
    galleryData: function () {
      this.scrolled = false
      this.pset = '' + new Date().getTime()
    }
  }
}
</script>

<style>

</style>
